import * as React from "react";

import FeatureSwitch from "../common/FeatureSwitch";
import { useSelectedSport } from "../common/context/sport";

import AskVolley from "./AskVolley";
import { ASK_VOLLEY_SPORTS } from "./AskVolley/constants";

/**
 * The home-screen callout: the Ask Volley prompt, for users holding
 * `ASK_VOLLEY_HOME_PROMPT` whose selected sport is in `ASK_VOLLEY_SPORTS`.
 *
 * This used to choose between that prompt and the DUPR App "Beacon" — a beta
 * invite shown to `DUPR_APP` pickleball users, which suppressed Ask Volley
 * until dismissed. The assessment is no longer a gated beta (it is offered to
 * every pickleball player from the library), so the invite and the suppression
 * it caused are both gone.
 */
export default function HomeCallout(): React.ReactNode {
    const { selected: sport } = useSelectedSport();

    return (
        <FeatureSwitch
            flag="ASK_VOLLEY_HOME_PROMPT"
            source="user_feature"
            enabled={<AskVolley />}
            default={null}
            additionalCondition={() => ASK_VOLLEY_SPORTS.has(sport)}
        />
    );
}
